<template>
  <base-dialog width="900px" :visible.sync="visible" class="location-dialog">
    <template v-slot:header>选择定位</template>
    <div class="address-container">
      <div class="left">
        <el-input
          v-model="searchText"
          @input="
            () => {
              this.searching = true
              this.debouncedSearch()
            }
          "
          placeholder="请搜索地点"
        >
          <template slot="append"><i class="el-icon-search"></i></template>
        </el-input>
        <div v-if="searchText && !poiList.length" class="tip">
          <span v-if="searching">搜 索 中 ...</span>
          <span v-else-if="!poiList.length" class="empty">搜索不到结果</span>
        </div>
        <div class="poi-list" v-ps>
          <div
            class="poi pointer"
            v-for="(poi, idx) in poiList"
            :key="idx"
            @click="handleSelect(poi)"
          >
            <div class="title">{{ poi.name }}</div>
            <div class="address">
              <span v-tip>{{ poi.address }}</span>
            </div>
          </div>
        </div>
      </div>
      <el-amap
        :vid="randomId"
        :plugin="plugins"
        @AMAP_READY_EVENT="initMap"
        :zoom="defaultZoomLevel"
      ></el-amap>
    </div>
  </base-dialog>
</template>

<script>
import { randomString } from "@/utils/common"
import BaseDialog from "@/components/UIComponents/BaseDialog"
import { getAreaString } from "@/utils/location"
export default {
  name: "location-dialog",
  components: { BaseDialog },
  props: {
    value: Object,
    scope: Object // {lng: xxx, lat: xxx, radius: 100}
  },
  computed: {
    hasValue() {
      return Boolean(this.value?.lng)
    },
    poiList() {
      if (this.searchText) {
        return this.searchResultList
          .filter(t => t.location)
          .map(t => ({
            name: t.name,
            address: this._.isString(t.address) ? t.address : t.name,
            location: t.location
          }))
      }
      let currentPosition = {
        name: "当前定位",
        address: this.currentPosition ? this.currentPosition.formattedAddress : "定位失败",
        // addressComponent: this.currentPosition.addressComponent,
        location: this.currentPosition?.position
      }
      let nearbyPoiList = this.nearbyPoiList.map(t => ({
        name: t.name,
        address: t.address,
        location: t.location
      }))
      return [currentPosition, ...nearbyPoiList].slice(0, 10)
    }
  },
  watch: {
    scope() {
      this.initScope(this.map)
    }
  },
  created() {
    this.debouncedSearch = this._.debounce(this.searchPlace, 300)
    this.autoComplete = new window.AMap.Autocomplete()
  },
  data() {
    return {
      randomId: randomString(10),
      visible: false,
      searching: false,
      searchText: "",
      plugins: ["PlaceSearch", "Autocomplete", "Geolocation", "Geocoder"],
      map: null,
      autoComplete: null,
      placeSearch: null,
      geolocation: null,
      positionPicker: null,
      defaultZoomLevel: 18,
      searchResultList: [],
      nearbyPoiList: [],
      currentPosition: {
        formattedAddress: "正在定位中, 请稍候"
      },
      debouncedSearch: null,
      currentItem: null
    }
  },
  methods: {
    open() {
      this.visible = true
      if (this.hasValue && this.map) {
        this.map.setZoomAndCenter(
          this.defaultZoomLevel,
          new window.AMap.LngLat(this.value.lng, this.value.lat)
        )
      }
    },
    initMap(map) {
      const AMap = window.AMap
      const AMapUI = window.AMapUI
      this.map = map
      // 画定位范围
      this.initScope(map)
      // 请求定位
      let locationPromise = this.initLocation(map)
      // 初始化选址UI组件
      AMapUI.loadUI(["misc/PositionPicker"], PositionPicker => {
        const positionPicker = new PositionPicker({ mode: "dragMap", map: this.map })
        positionPicker.on("success", positionResult => {
          this.nearbyPoiList = positionResult.regeocode?.pois || []
          let item = this.currentItem
          if (item) {
            this.$emit("input", {
              lat: item.location.Q,
              lng: item.location.R,
              // poiName: item.name == "当前定位" ? "" : item.name,
              poiName: item.name,
              address: item.address,
              area: getAreaString(positionResult?.regeocode?.addressComponent)
            })
            this.currentItem = null
            return
          }
          this.$emit("input", {
            lat: positionResult.position.Q,
            lng: positionResult.position.R,
            poiName:
              positionResult.regeocode?.aois?.[0]?.name ||
              positionResult.regeocode?.pois?.[0]?.name,
            address: positionResult.address,
            area: getAreaString(positionResult?.regeocode?.addressComponent)
          })
        })
        positionPicker.on("fail", positionResult =>
          console.error("获取当前坐标失败", positionResult)
        )
        locationPromise.then(location => {
          this.currentPosition = location
          if (this.hasValue) {
            positionPicker.start(new AMap.LngLat(this.value.lng, this.value.lat))
          } else {
            positionPicker.start(location?.position)
          }
        })

        this.positionPicker = positionPicker
      })
    },
    // 初始化定位范围
    initScope(map) {
      if (!map) return
      const AMap = window.AMap
      if (this.scopeCircle) {
        // scopeCircle 无需存到data中
        map.remove(this.scopeCircle)
        this.scopeCircle = null
      }
      if (this.scope) {
        this.scopeCircle = new AMap.Circle({
          center: new AMap.LngLat(this.scope.lng, this.scope.lat), // 圆心位置
          radius: this.scope.radius, // 半径
          strokeColor: "blue", // 线颜色
          strokeOpacity: 1, // 线透明度
          strokeWeight: 2, // 线粗细度
          fillColor: "blue", // 填充颜色
          fillOpacity: 0.35 // 填充透明度
        })
        map.add(this.scopeCircle)
      }
    },
    // 初始化定位
    initLocation(map) {
      const AMap = window.AMap

      this.geolocation = new AMap.Geolocation({
        enableHighAccuracy: true, // 是否使用高精度定位，默认:true
        timeout: 3000, // 超过3秒后停止定位，默认：无穷大
        maximumAge: 0, // 定位结果缓存0毫秒，默认：0
        convert: true, // 自动偏移坐标，偏移后的坐标为高德坐标，默认：true
        showButton: true, // 显示定位按钮，默认：true
        buttonPosition: "LB", // 定位按钮停靠位置，默认：'LB'，左下角
        buttonOffset: new AMap.Pixel(10, 20), // 定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
        showMarker: true, // 定位成功后在定位到的位置显示点标记，默认：true
        showCircle: true, // 定位成功后用圆圈表示定位精度范围，默认：true
        panToLocation: false, // 定位成功后将定位到的位置作为地图中心点，默认：true
        zoomToAccuracy: false // 定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
      })
      map.addControl(this.geolocation)
      return new Promise(resolve => {
        this.geolocation.getCurrentPosition((state, result) => {
          resolve(state == "error" ? null : result)
        })
      })
    },
    searchPlace() {
      this.searching = true
      return new Promise((resolve, reject) => {
        this.autoComplete.search(this.searchText, (status, result) => {
          this.searching = false
          this.searchResultList = result.tips || []
          resolve()
        })
      })
    },
    handleSelect(item) {
      this.currentItem = item
      this.map.setZoomAndCenter(this.defaultZoomLevel, item.location)
      this.visible = false
    }
  }
}
</script>

<style scoped lang="scss">
.location-dialog {
  ::v-deep {
    .el-dialog {
      .el-dialog__body {
        color: #606266;
        display: flex;
        max-height: 640px;
        height: calc(100vh - 94px);
        padding: 0;
      }
    }
  }
  .address-container {
    flex: 1;
    display: flex;
    position: relative;
    .left {
      padding: 0 22px;
      flex: 2;
      display: flex;
      flex-flow: column;
      .el-input {
        margin: 5px 0;
      }
      .tip {
        display: flex;
        height: 100px;
        align-items: center;
        justify-content: center;
      }
      .poi-list {
        flex: 1;
        .poi {
          height: 57px;
          justify-content: center;
          display: flex;
          flex-flow: column;
          padding: 0 16px;
          border-bottom: 1px solid rgba(0, 0, 0, 0.05);
          font-size: 13px;
          &:hover {
            background: #f5f7fa;
          }
          .title {
            color: #333;
            font-weight: bold;
          }
          .address {
            width: 300px;
            color: #9e9e9e;
          }
        }
      }
    }
    .el-vue-amap-container {
      flex: 3;
    }
  }
}
</style>
